import React from "react";
import BackGroundImage from "../assets/backgrounds/idp.jpg";
import Navbar from "./_shared/NavBar";
import SecondDescImage from "../assets/secondPic/idp.jpg";
import ImageVendeuse from "../assets/cartes/idp.jpg";
import FooterSection from "./_shared/FooterSection";

const IlesDePaix = () => {
    return (
        <div className="bg-gray-100 overflow-hidden">
            {/* Hero Section - Made taller on mobile */}
            <div
                className="relative bg-cover bg-center h-96 sm:h-[30rem] md:h-[35rem] lg:h-[40rem]"
                style={{backgroundImage: `url(${BackGroundImage})`}}
            >
                <Navbar/>
                <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center px-4">
                    <h1 className="font-anton text-4xl sm:text-5xl md:text-6xl lg:text-8xl text-white font-extrabold italic text-center">
                        Opération Iles de Paix
                    </h1>
                </div>
            </div>

            {/* First Content Section */}
            <section className="w-full max-w-full mx-auto my-8 px-4 md:px-6 lg:px-8">
                <div className="flex flex-col lg:flex-row gap-8">
                    <div className="w-full lg:w-1/2">
                        <img
                            className="w-full h-auto shadow-lg rounded-lg"
                            src={SecondDescImage}
                            alt="groupe"
                        />
                    </div>
                    <div className="w-full lg:w-1/2 mt-6 lg:mt-0">
                        <p className="text-gray-700 leading-relaxed mb-4 text-lg md:text-xl lg:text-2xl">
                            Chaque année, début Janvier, toute l'unité se mobilise pour participer à l'action îles de
                            Paix. Cette ONG Belge, fondée par le père Pire, aide directement plus de 200 000 personnes
                            dans 4 pays en Afrique et en Amérique du Sud. Avec comme slogan "si tu donnes un poisson à
                            un homme il mangera un jour, si tu lui apprends à pêcher il mangera toute sa vie",
                            l'organisation travaille dans les zones rurales défavorisées et mise sur des améliorations
                            durables plutôt que de simples injections d'argent ci et là.

                            <br/><br/>

                            Durant tout un week-end les loups, les lutins, mais surtout les scouts, les guides, les
                            chefs et les anciens vendent des modules au profit de cette organisation.

                            <br/><br/>

                            L'Unité n'est pas peu fière d'occuper depuis des années la place de 2nd meilleur vendeur de
                            Liège!

                            <br/><br/>

                            Pour plus d'informations sur le beau travail de cette ONG nous vous invitons a visiter leur site internet : <a href="https://www.ilesdepaix.org/" target='_blank' className="text-green-700 font-bold italic">îles de paix</a>
                        </p>
                    </div>
                </div>
            </section>

            {/* Stats Section */}
            <section className="bg-gray-800 py-16 md:py-24 lg:py-32 text-white w-full">
                <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-8xl font-anton text-center mb-12 italic px-4">
                    Quelques chiffres
                </h2>
                <div className="flex flex-col md:flex-row flex-wrap justify-center items-center text-center gap-8 md:gap-16 px-4">
                    {/* Chiffre 15k+ */}
                    <div className="w-full md:w-64 mb-8 md:mb-0">
                        <h3 className="text-4xl md:text-5xl lg:text-6xl font-bold">
                            15k<span className="text-green-700">+</span>
                        </h3>
                        <p className="mt-4 text-base lg:text-lg">
                            c'est le nombre d'argent récolté en 2025 par l'unité Ste-Véronique
                        </p>
                    </div>
                    {/* Chiffre 50+ (Années de participation) */}
                    <div className="w-full md:w-64 mb-8 md:mb-0">
                        <h3 className="text-4xl md:text-5xl lg:text-6xl font-bold">
                            50<span className="text-green-700">+</span>
                        </h3>
                        <p className="mt-4 text-base lg:text-lg">
                            c'est le nombre d'année depuis lesquelles l'unité participe à la campagne îles de paix
                        </p>
                    </div>
                    {/* Chiffre 50+ (Placeholder) */}
                    <div className="w-full md:w-64">
                        <h3 className="text-4xl md:text-5xl lg:text-6xl font-bold">
                            150<span className="text-green-700">+</span>
                        </h3>
                        <p className="mt-4 text-base lg:text-lg">
                            c'est le nombre de chefs et d'animés qui se mobilisent chaque année pour la cause
                        </p>
                    </div>
                </div>
            </section>

            {/* Quote Section */}
            <section className="bg-white py-12 md:py-20 w-full">
                <div className="w-full px-4">
                    <div className="flex flex-col md:flex-row items-center">
                        <div className="w-full md:w-1/2 text-center md:text-end mb-8 md:mb-0">
                            <h2 className="text-3xl sm:text-4xl md:text-5xl font-anton text-green-800 italic leading-tight md:pr-8 mb-6 md:mb-0">
                                "Si tu donnes un poisson à un homme il mangera un jour,
                                si tu lui apprends à pêcher il mangera toute sa vie"
                            </h2>
                        </div>
                        <div className="w-full md:w-1/2 flex justify-center">
                            <img
                                className="w-full max-w-lg h-auto shadow-md rounded-lg"
                                src={ImageVendeuse}
                                alt="Citations îles de paix"
                            />
                        </div>
                    </div>
                </div>
            </section>

            {/* Footer Section */}
            <FooterSection/>
        </div>
    );
};

export default IlesDePaix;